import { Grid } from "@material-ui/core"
import { TextButton, Elements } from "@tfo/common"
import React from "react"
import personnummer from 'personnummer.js'
import { useIntl } from "react-intl"
import CustomerPortalDialog from "../../../containers/client/common/CustomerPortalDialog"
const { Paragraph } = Elements

const DuplicateOrderDetectedDialog = ({ open, onClose, nationalId }: 
    { open: boolean, onClose: () => void, nationalId: string}) => {
    const intl = useIntl()
    const normalisedNationalId = nationalId && personnummer
        .normalise(nationalId, {normaliseFormat: 'YYYYMMDD-NNNN'});
    const formattedNationalId = normalisedNationalId !== undefined? normalisedNationalId.replace('-', '‑') : ''
    return (
        <>
            {
                <CustomerPortalDialog
                    open={open}
                    onClose={onClose}
                    title={intl.formatMessage({ id: 'new.report.order.form.modal.duplicate.order.detected.title' })}
                    content={
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Paragraph style={{whiteSpace:'pre-line'}}>
                                    {intl.formatMessage({ 
                                        id: 'new.report.order.form.modal.duplicate.order.detected.infotext' }, 
                                        {nationalId: formattedNationalId})} 
                                </Paragraph>
                            </Grid>
                        </Grid>
                    }
                    footer={
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item xs={6} md={4}>
                                <TextButton onClick={onClose} style={{width: '100%' }}>
                                    {intl.formatMessage({ id: 'new.report.order.form.modal.duplicate.order.detected.confirm' })}
                                </TextButton>
                            </Grid>
                        </ Grid>
                    } />
            }
        </>
    )
}

export default DuplicateOrderDetectedDialog
